



























import { Vue, Component } from 'vue-property-decorator';
import validity_batch from './validityPeriod.vue';  // 效期批次查询
import batch_inventory from './batchInventorySearch.vue';  // 批次查询
import new_inbound_batch from './inboundBatchInventory.vue';  // 入库批次查询
import production_batch from './productionBatchInventory.vue';  // 生产批次查询
import consignor_batch from './ownerBatchInventory.vue';  // 货主批次查询

/** 批次库存 tab 配置项类型 */
interface TabConfig {
  /** 组件标识，与后端返回值保持一致 */
  str_value: string | null;
  /** Tab 显示文案 */
  text: string;
  /** 是否展示 */
  is_show: boolean;
}

@Component({
  components: {
    validity_batch,
    batch_inventory,
    new_inbound_batch,
    production_batch,
    consignor_batch,
  },
})
export default class BatchInventoryPage extends Vue {
  /** 当前激活的 tab */
  public activeTab: string = '';

  /** 批次库存 tab 配置列表 */
  private tabList: TabConfig[] = [];

  /**
   * 生命周期 - 组件创建完成
   *
   * @returns {void}
   */
  protected created(): void {
    this.fetchTabList();
  }

  /**
   * 获取批次库存 tab 配置
   *
   * @returns {Promise<void>} 异步请求 Promise
   */
  private async fetchTabList(): Promise<void> {
    try {
      const { data } = await this.$api.warehouse.queryEffectBatchInventoryConfig();
      const enumList = Array.isArray(data?.enum_list) ? data.enum_list : [];
      this.tabList = enumList;
      const firstVisibleTab = this.visibleTabs[0];
      this.activeTab = firstVisibleTab ? this.resolveTabKey(firstVisibleTab) : '';
    } catch (error) {
      console.error('获取批次属性配置失败，请稍后重试', error);
      this.tabList = [];
      this.activeTab = '';

    }
  }

  /**
   * 获取需要展示的 tab 列表
   *
   * @returns {TabConfig[]} 需要渲染的 tab 配置数组
   */
  get visibleTabs(): TabConfig[] {
    return this.tabList.filter((tab) => tab.is_show);
  }

  /**
   * 获取批次属性下拉选项
   *
   * @returns {TabConfig[]} 批次属性选项列表
   */
  private get batchAttributeOptions(): TabConfig[] {
    return this.tabList.filter((tab) => tab.is_show);
  }

  /**
   * 获取组件所需的属性
   *
   * @param {TabConfig} tab 当前tab配置
   * @returns {Record<string, unknown>} 组件绑定的属性对象
   */
  public getComponentProps(_tab: TabConfig): Record<string, unknown> {
    console.log('this.batchAttributeOptions', this.batchAttributeOptions);
    const batchAttributeEnum = this.batchAttributeOptions.filter((tab) => tab.str_value !== this.$enum.warehouse.BatchAttributeEnum.BATCH_INVENTORY) || [];
    return {
      batchAttributeEnum,
    };
  }

  /**
   * 获取 tab 对应的组件标识
   *
   * @param {TabConfig} tab 当前 tab 配置项
   * @returns {string} 组件标识
   */
  public resolveTabKey(tab: TabConfig): string {
    return tab.str_value || '';
  }

  /**
   * 构造批次属性配置 mock 数据，便于本地自测
   *
   * @returns {TabConfig[]} 批次属性 mock 列表
   */
  private createMockTabList(): TabConfig[] {
    return [
      {
        str_value: this.$enum.warehouse.BatchAttributeEnum.BATCH_INVENTORY,
        text: '批次库存',
        is_show: false,
      },
      {
        str_value: this.$enum.warehouse.BatchAttributeEnum.VALIDITY_BATCH,
        text: '效期批次',
        is_show: true,
      },
      {
        str_value: this.$enum.warehouse.BatchAttributeEnum.NEW_INBOUND_BATCH,
        text: '入库批次',
        is_show: true,
      },
      {
        str_value: this.$enum.warehouse.BatchAttributeEnum.PRODUCTION_BATCH,
        text: '生产批次',
        is_show: true,
      },
      {
        str_value: this.$enum.warehouse.BatchAttributeEnum.CONSIGNOR_BATCH,
        text: '货主批次',
        is_show: false,
      },
    ];
  }
}
